'use strict';

import { queryFirst, addClass, removeClass, hasClass, queryAll, setAttribute, toggleClass, renderFragment, scrollToSection } from '../domUtil';
import base from './base';
import { updateProductData, handleColor, handleSize } from 'fitpredictor/product/secretsauce';
import { initRadioGroupKeyboardNav, normalizeRadioGroup } from '../components/accessibleRadioGroup';
import { appendToUrl } from '../util';

const { isShippingPreferencesViewEnabled, isEarlyAccessElement, enableAddAllToToteButton, toggleSelectSizeInfo } = require('./helper');
const { availabilityMessageTmpl, availabilityMessageOOS, availabilityMessagePreorder, ispuAvailabilityMessageTmpl, ispuLowStockMessageTmpl } = require('../templates').productDetail;
const $body = $('body');
const sizeChartClasses = 'no-scroll size-chart-visible';
var Hammer = require('hammerjs');
const KEYCODE_TAB = 9;
const TabKey = 'Tab';
const {
    IN_STOCK_STATUS: IN_STOCK,
    NOT_AVAILABLE_STATUS: NOT_AVAILABLE,
    PREORDER_STATUS: PREORDER,
    HIDDEN_CLASS,
    NOT_AVAILABLE_CLASS,
    SELECTED_CLASS,
    ONE_SIZE_ID,
    ONE_SIZE_LABEL,
    EVENT_KEY_SPACE,
    EVENT_KEY_ENTER,
    KEYCODE_ENTER,
    KEYCODE_SPACE
} = require('../constants');
const { SHIP_TO_LOW_INVENTORY_CLASS } = require('../components/shippingPreference/constants');
const { initPopoverPromotions, initPopoverClose, initPopoverCloseSelector, initPopoverWishList } = require('../popover');
const { initCarouselElement, initCarousels } = require('../components/swiperCarousel').default;
const { initVideos, hasVideos } = require('../components/video').default;
import { getNestedValue } from '../util';
import { hideStrikeHearts, setWishlistProductId, showStrikeHearts } from '../wishlist/helper';
import { updatePromoBlockContent } from '../helpers/productHelper';

let zoomedState = false;
const cartVariantIds = [];

function buyBarSyncIds(scope) {
    queryAll('.remove-product-btn[data-pid], .cart-product-line-item[data-pid]', scope).forEach(el => {
        if (el.dataset.pid && !cartVariantIds.includes(el.dataset.pid)) {
            cartVariantIds.push(el.dataset.pid);
        }
    });
}

function buyBarSyncHtml(html) {
    const fragment = renderFragment(html);
    const minicartTemplate = queryFirst('.mini-cart-template', fragment);
    if (minicartTemplate?.content) {
        buyBarSyncIds(minicartTemplate.content);
    }
}

function buyBarInCart(variantId) {
    return Boolean(variantId && cartVariantIds.includes(variantId));
}

function buyBarUpdateState(variantId) {
    const buybarButton = queryFirst('.js-buybar-btn');
    const idToCheck = variantId || queryFirst('.pdp-container .size-btn.selected')?.dataset?.variationId;

    if (!buybarButton || !idToCheck || !hasClass(buybarButton, 'selected')) {
        return;
    }

    const sizeBtn = queryFirst(`.pdp-container .size-btn[data-variation-id="${idToCheck}"]`)
        || queryFirst('.pdp-container .size-btn.selected');

    if (buyBarInCart(idToCheck) && sizeBtn && !hasClass(sizeBtn, NOT_AVAILABLE_CLASS)) {
        addClass(buybarButton, 'm-done');
    } else {
        removeClass(buybarButton, 'm-done');
    }
}

/**
 * Handling zoomin effect on product image slider
 */
function handleProductImageZoom(carousel) {
    const pdpModalCarouselEl = carousel;
    const imageZoomUrl = pdpModalCarouselEl.dataset.image;
    const imagePresetUrl = pdpModalCarouselEl.dataset.preset;

    const imageObserver = new MutationObserver(function (mutationList) {
        for (let mutation of mutationList) {
            if (mutation.type === 'childList') {
                const { target, addedNodes } = mutation;
                const baseImg = queryFirst('.img-fluid', target);
                const zoomAlt = baseImg.getAttribute('alt') + ' Zoomed';
                setAttribute(addedNodes, 'alt', zoomAlt);
            }
        }
    });

    if (pdpModalCarouselEl) {
        const pdpImages = queryAll('.swiper-slide > img.img-fluid', pdpModalCarouselEl);

        pdpImages.forEach((imageEl, index) => {
            if (!imageEl) {
                return;
            }

            imageObserver.observe(imageEl.parentNode, { childList: true });

            if (window.matchMedia('(hover: none)').matches) {
                const hammer = new Hammer(imageEl, {});
                let transform = '';
                let pinchData = null;
                let rafPending = false;
                // State variables
                let xPos = { current: 0, last: 0 };
                let yPos = { current: 0, last: 0 };
                let scale = { current: 1, last: 1, min: 1, max: 4 }; // Max zoom set to 4x

                // --- Helper Functions ---

                const clampPosition = function (el) {
                    const containerRect = el.parentElement.getBoundingClientRect();
                    const scaledImgWidth = el.clientWidth * scale.current;
                    const scaledImgHeight = el.clientHeight * scale.current;

                    // Horizontal clamp
                    const maxPanX = Math.max(0, (scaledImgWidth - containerRect.width) / 2);
                    xPos.current = Math.min(maxPanX, Math.max(-maxPanX, xPos.current));

                    // Vertical clamp
                    const maxPanY = Math.max(0, (scaledImgHeight - containerRect.height) / 2);
                    yPos.current = Math.min(maxPanY, Math.max(-maxPanY, yPos.current));
                };

                const transformElement = function (el, transition = false) {
                    if (transition) {
                        el.style.transition = 'transform 0.3s ease';
                        el.style.transform = `translate(${xPos.current}px, ${yPos.current}px) scale(${scale.current})`;
                        return;
                    }

                    if (!rafPending) {
                        rafPending = true;
                        requestAnimationFrame(() => {
                            el.style.transition = 'none';
                            el.style.transform = `translate(${xPos.current}px, ${yPos.current}px) scale(${scale.current})`;
                            rafPending = false;
                        });
                    }
                };

                const resetZoom = function (el) {
                    scale.current = 1;
                    scale.last = 1;
                    xPos.current = 0;
                    xPos.last = 0;
                    yPos.current = 0;
                    yPos.last = 0;
                    zoomedState = false;
                    pinchData = null;

                    removeClass(el.parentNode, 'zoomed');

                    if (pdpModalCarouselEl?.swiper) {
                        pdpModalCarouselEl.swiper.enable(); // always re-enable
                    }

                    transformElement(el, true);
                };

                // --- Hammer.js Event Listeners ---

                hammer.get('pinch').set({ enable: true });
                hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL });
                hammer.get('doubletap').set({ enable: true });

                hammer.on('panstart panmove panend pinchstart pinchmove pinchend doubletap tap', function (e) {
                    e.srcEvent.preventDefault();
                    e.srcEvent.stopPropagation();

                    let el = e.target;

                    // eslint-disable-next-line default-case
                    switch (e.type) {
                        case 'doubletap':
                            if (scale.current <= 1) {
                                const rect = el.getBoundingClientRect();
                                const tapX = e.center.x - rect.left;
                                const tapY = e.center.y - rect.top;

                                scale.current = scale.max / 2;
                                zoomedState = true;
                                addClass(el.parentNode, 'zoomed');
                                pdpModalCarouselEl.swiper.disable();

                                // Center around tap point
                                xPos.current = e.center.x - tapX * scale.current - rect.left;
                                yPos.current = e.center.y - tapY * scale.current - rect.top;

                                clampPosition(el);
                            } else {
                                resetZoom(el);
                            }

                            scale.last = scale.current;
                            xPos.last = xPos.current;
                            yPos.last = yPos.current;
                            transformElement(el, true);
                            break;

                        case 'tap':
                            if (zoomedState) {
                                resetZoom(el);
                            }
                            break;

                        case 'pinchstart':
                            scale.last = scale.current;
                            const rect = el.getBoundingClientRect(); // cache once
                            pinchData = {
                                rect,
                                x: (e.center.x - rect.left - xPos.current) / scale.current,
                                y: (e.center.y - rect.top - yPos.current) / scale.current
                            };
                            break;

                        case 'pinchmove':
                            let newScale = scale.last * e.scale;
                            if (newScale < scale.min) newScale = scale.min;
                            if (newScale > scale.max) newScale = scale.max;
                            scale.current = newScale;

                            zoomedState = scale.current > scale.min;
                            if (zoomedState) {
                                addClass(el.parentNode, 'zoomed');
                                pdpModalCarouselEl.swiper.disable();
                            }

                            if (pinchData) {
                                // use cached rect from pinchstart
                                xPos.current = e.center.x - pinchData.x * scale.current - pinchData.rect.left;
                                yPos.current = e.center.y - pinchData.y * scale.current - pinchData.rect.top;
                            }

                            clampPosition(el);
                            transformElement(el); // no transition
                            break;

                        case 'pinchend':
                            if (scale.current > scale.max) scale.current = scale.max;

                            if (scale.current <= scale.min + 0.01) {
                                // allow small tolerance
                                resetZoom(el); // full reset, re-enable swiper
                            } else {
                                clampPosition(el);
                                scale.last = scale.current;
                                transformElement(el, true);
                            }
                            pinchData = null;
                            break;

                        case 'panstart':
                            if (zoomedState) {
                                pdpModalCarouselEl.swiper.disable();
                                xPos.last = xPos.current;
                                yPos.last = yPos.current;
                            }
                            break;

                        case 'panmove':
                            if (zoomedState) {
                                xPos.current = xPos.last + e.deltaX;
                                yPos.current = yPos.last + e.deltaY;

                                clampPosition(el);
                                transformElement(el);
                            }
                            break;
                    }

                    $(el).on('zoom:imageChange', () => {
                        resetZoom(el);
                    });
                });
            } else {
                const scaleOnHover = 2;
                let imageContainer = $(imageEl).parent();

                imageContainer.on('click', function () {
                    imageContainer.addClass('zoomed');
                    zoomedState = true;
                    pdpModalCarouselEl.swiper.disable();
                });

                imageContainer.zoom({
                    on: 'click',
                    url: imageEl.getAttribute('src'),
                    touch: false,
                    duration: 300,
                    magnify: scaleOnHover,
                    onZoomOut: function () {
                        imageContainer.removeClass('zoomed');
                        zoomedState = false;
                        pdpModalCarouselEl.swiper.enable();
                    }
                });
            }
        });
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {Array} variationAttributes - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateSelectedSwatchProductName(variationAttributes, $productContainer) {
    if (Array.isArray(variationAttributes) && variationAttributes.length) {
        const colorVariationObject = variationAttributes.find(attribute => attribute.attributeId === 'color');
        const colorLabel = $productContainer.find('.selected-swatch').data('color-label');

        if (colorVariationObject && Array.isArray(colorVariationObject.values) && colorVariationObject.values.length) {
            const selectedSwatchObject = colorVariationObject.values.find(eachValue => eachValue.selected);

            $productContainer.find('.selected-swatch-name').text(selectedSwatchObject ? `${(colorLabel && colorLabel + ' ') || ''}${selectedSwatchObject.displayValue}` : '');
        }
    }
}

/**
 * This method manages Notify me dialog content.
 *
 * !! For inline NotifyMe box please see handleNotifyMeBlock method
 *
 * @param {Object} productData - Product data
 * @param {Object} productContainer - Product Container DOM element
 */
function handleNotifyMe(productData, productContainer) {
    const addToCartSection = queryFirst('.prices-add-to-cart-actions', productContainer);
    const buyBarAddToCart = queryFirst('.js-buybar-btn');
    const notifyContainer = queryFirst('.js-notify-me-container', productContainer);
    const notifyMeButton = queryFirst('.notify-me-btn', productContainer);
    const buyBarNotifyMeButton = queryFirst('.js-buybar .notify-me-btn');
    const notifyMeDesc = queryFirst('.js-notify-me-desc', productContainer);
    const availabilityMessageEl = queryFirst('.product-availability', productContainer);
    const { available, isNotifyMeEnabled, id, formattedPrice, forceOutOfStock, imageData } = productData;
    if (!available && isNotifyMeEnabled && !forceOutOfStock) {
        addClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
        removeClass([notifyMeDesc, notifyMeButton, buyBarNotifyMeButton, availabilityMessageEl], HIDDEN_CLASS);
        const notifyImageElement = queryFirst('.js-notify-img img', notifyContainer);
        if (imageData && notifyImageElement) {
            const { alt, url, srcset } = imageData[0];
            const imageHasLoaded = hasClass(notifyImageElement, 'lz-loaded');

            notifyImageElement.setAttribute(imageHasLoaded ? 'src' : 'data-src', url);
            notifyImageElement.setAttribute(imageHasLoaded ? 'srcset' : 'data-srcset', srcset);
            notifyImageElement.setAttribute('alt', alt);
        }
        // Insert price
        queryFirst('.js-notify-price', notifyContainer).textContent = formattedPrice;
        // Insert color value
        const notifyColor = queryFirst('.js-notify-color', notifyContainer);
        queryFirst('.js-notify-color-label', notifyColor).textContent = queryFirst('.selected-swatch', productContainer).dataset.colorLabel;
        queryFirst('.js-notify-color-value', notifyColor).textContent = queryFirst('.ssColor', productContainer).value;
        // Insert size value
        const notifySize = queryFirst('.js-notify-size', notifyContainer);
        queryFirst('.js-notify-size-label', notifySize).textContent = queryFirst('.size-display-name', productContainer).value + ':';
        queryFirst('.js-notify-size-value', notifySize).textContent = queryFirst('.size-btn.selected', productContainer).dataset.attrValue;
        if (id) {
            document.getElementById('notifySku').value = id;
        }
        const customerEmail = (document.getElementById('notifyEmail') || {}).value;
        if (customerEmail) {
            queryFirst('.notify-email').value = customerEmail;
        }
        removeClass(queryFirst('.js-notify-me-desc'), HIDDEN_CLASS);
        removeClass(queryFirst('.js-notify-form'), HIDDEN_CLASS);
        addClass(queryFirst('.js-notify-confirm-block'), HIDDEN_CLASS);

        $body.trigger('product:notifyMeShown', productContainer);
    } else {
        removeClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
        if (availabilityMessageEl) {
            removeClass(availabilityMessageEl, HIDDEN_CLASS);
        }
        addClass([notifyMeDesc, notifyMeButton, buyBarNotifyMeButton], HIDDEN_CLASS);

        $body.trigger('product:notifyMeHidden', productContainer);
    }
}

/**
 *
 * @param {*} productContainer
 * @param {*} selectedSizeValue
 * @returns
 */
function updateColorElements(productContainer, selectedSizeValue) {
    const masterId = productContainer.dataset.masterid;
    const productInfoVariants = window.productInfo[masterId].variants;
    const allColorElements = queryAll('button.color-attribute', productContainer);
    const { productInventory } = window;

    allColorElements.forEach(colorElement => {
        let selectedColorElement = queryFirst('.swatch-circle', colorElement);
        let selectedColorId = selectedColorElement.dataset.attrValue;
        let product = productInfoVariants[selectedColorId];

        if (colorElement && Object.prototype.hasOwnProperty.call(product, 'sizes') && Object.prototype.hasOwnProperty.call(product.sizes, selectedSizeValue)) {
            const sizeID = product.sizes[selectedSizeValue].ID;

            if (Object.prototype.hasOwnProperty.call(productInventory[masterId].variants, sizeID)) {
                const status = productInventory[masterId].variants[sizeID].availabilityStatus;

                if (status === NOT_AVAILABLE) {
                    addClass(colorElement, NOT_AVAILABLE_CLASS);
                } else {
                    removeClass(colorElement, NOT_AVAILABLE_CLASS);
                }
            } else if (!hasClass(colorElement, NOT_AVAILABLE_CLASS)) {
                addClass(colorElement, NOT_AVAILABLE_CLASS);
            }
        } else if (!hasClass(colorElement, NOT_AVAILABLE_CLASS)) {
            addClass(colorElement, NOT_AVAILABLE_CLASS);
        }
    });
}
/**
 * handles size change
 * @param {Object} productContainer - product container html element
 * @param {string} selectedSizeValue - Selected size value
 */
function onSizeChangeHandler(productContainer, selectedSizeValue) {
    updateColorElements(productContainer, selectedSizeValue);
    removeClass(queryAll('.size-btn', productContainer), 'selected');
    addClass(this, 'selected');

    const selecedSizeElements = queryAll(`.size-btn[data-value-id="${selectedSizeValue}"]:not(.selected)`, productContainer);
    addClass(selecedSizeElements, 'selected');

    const sizeContainer = this.closest('.size-container');
    const assistiveElements = queryAll('.selected-assistive-text', sizeContainer);
    assistiveElements.forEach(eachElement => {
        if (eachElement.textContent.includes(eachElement.dataset.outOfStock)) {
            eachElement.textContent = eachElement.dataset.outOfStock;
        } else {
            eachElement.textContent = '';
        }
    });
    const assistiveElementOfSelected = queryFirst('.selected-assistive-text', this.closest('.size-list'));
    const { selectedText, outOfStock } = assistiveElementOfSelected.dataset;
    if (hasClass(this, NOT_AVAILABLE_CLASS)) {
        assistiveElementOfSelected.textContent = outOfStock;
    } else {
        assistiveElementOfSelected.textContent = selectedText;
    }
    removeClass(queryFirst('.size-seperator', productContainer), HIDDEN_CLASS);
    const selectedSize = queryFirst('.selected-size', productContainer);
    if (selectedSize && selectedSize !== sizeContainer) {
        selectedSize.innerHTML = sizeContainer.innerHTML;
        removeClass(selectedSize, HIDDEN_CLASS);

        // Cloned buttons retain PDP tabindex values, ensure only one ISPU size is tabbable
        normalizeRadioGroup(selectedSize, '.size-btn[role="radio"]', {
            selectedClass: SELECTED_CLASS,
            notAvailableClass: NOT_AVAILABLE_CLASS
        });
    }

    // update selected size input
    const selectedSizeInput = queryFirst('.js-selected-size', productContainer);
    if (selectedSizeInput) {
        // change size label ('1 SZ' to 'One Size'), if it is '1 SZ'
        selectedSizeInput.textContent = selectedSizeValue === ONE_SIZE_ID ? ONE_SIZE_LABEL : selectedSizeValue;
    }

    // Ensure PDP size radiogroups maintain a single tabbable radio (roving tabindex)
    const sizeGroup = sizeContainer.closest('.size-container[role="radiogroup"]') || sizeContainer;
    normalizeRadioGroup(sizeGroup, '.size-btn[role="radio"]', {
        selectedClass: SELECTED_CLASS,
        notAvailableClass: NOT_AVAILABLE_CLASS
    });

    // update buybar button
    const buybarButton = queryFirst('.js-buybar-btn');
    const buybarPriceEl = queryFirst('.js-buybar-price');
    const buybarSoldEl = queryFirst('.js-buybar-sold');
    const buybarSizeEl = queryFirst('.js-buybar-size');
    if (buybarSizeEl) {
        const displaySize = selectedSizeValue === ONE_SIZE_ID ? ONE_SIZE_LABEL : selectedSizeValue;
        buybarSizeEl.textContent = `Size: ${displaySize}`;
    }
    if (buybarButton) {
        if (queryAll('.size-list', sizeContainer).length > 1) {
            if (hasClass(this, NOT_AVAILABLE_CLASS)) {
                addClass(buybarButton, 'button-secondary', 'js-buybar-select');
                removeClass(buybarButton, 'button-primary');
                addClass([buybarPriceEl, buybarSizeEl], HIDDEN_CLASS);
                removeClass(buybarSoldEl, HIDDEN_CLASS);
            } else {
                addClass(buybarButton, 'button-primary');
                removeClass(buybarButton, 'button-secondary', 'js-buybar-select');
                removeClass([buybarPriceEl, buybarSizeEl], HIDDEN_CLASS);
                addClass(buybarSoldEl, HIDDEN_CLASS);
            }
        }
        addClass(buybarButton, 'selected');
        buyBarUpdateState(this.dataset.variationId);
    }
}

/**
 * Updates Early Access CTAs for a product container based on the selected color variant.
 * @param {HTMLElement} productContainer - product container DOM element
 * @param {Object} [earlyAccess] - early access data for the selected variant group
 */
function updateEarlyAccessCta(productContainer, earlyAccess) {
    if (!productContainer) return;

    const resolvedEarlyAccess = earlyAccess || (() => {
        const masterId = productContainer.dataset.masterid;
        const productInfo = window?.productInfo?.[masterId];
        const selectedSwatch = queryFirst('.color-attribute .swatch-circle.selected', productContainer);
        const selectedColorId = selectedSwatch?.dataset.attrValue;
        return productInfo?.variants?.[selectedColorId]?.earlyAccess || null;
    })();

    const productContainerEarlyAccessIcons = queryAll('.pdp-details-header .loyalty-early-access-lock-container', productContainer);
    const isEarlyAccessProduct = !!resolvedEarlyAccess?.isEarlyAccessProduct;
    const isTierEligible = base.isTierEligibleForEarlyAccess(resolvedEarlyAccess);

    if (!productContainerEarlyAccessIcons.length) {
        base.handleEarlyAccessCta(
            productContainer,
            isEarlyAccessProduct,
            null,
            isTierEligible,
            !!resolvedEarlyAccess?.isAnnualMemberGift
        );
        return;
    }

    productContainerEarlyAccessIcons.forEach(productContainerEarlyAccessIcon => {
        base.handleEarlyAccessCta(
            productContainer,
            isEarlyAccessProduct,
            productContainerEarlyAccessIcon,
            isTierEligible,
            !!resolvedEarlyAccess?.isAnnualMemberGift
        );
    });
}

/**
 * update quickview product info on product variation change
 * @param {string} selectedSizeValue - Selected size value
 * @param {int} selectedColorId - selected color id
 * @param {Object} productContainer - product container html element
 * @param {Object} currentSizeElement - current active size element
 */
function updateQuickViewProductInfo(selectedSizeValue, selectedColorId, productContainer, currentSizeElement) {
    const quickViewInfo = window.quickviewProductInfo;
    const { productInfo } = quickViewInfo;
    const variantGroupData = productInfo.variants[selectedColorId];
    const { sizes, images, formattedPrice, standardPrice, price, vgProductDetailsUrl, isDirectlyPurchasable, wishlistDisabled, isFinalSale } = variantGroupData;
    const ispu = base.updateImageDetails(images.extrasmall);
    const selectedSizeData = sizes[selectedSizeValue];
    const addToCartButton = queryFirst('.add-to-cart', productContainer);
    const notifyMeButton = queryFirst('.notify-me-btn', productContainer);
    const buyBarNotifyMeButton = queryFirst('.js-buybar .notify-me-btn');
    const notifyMeDesc = queryFirst('.notify-me-desc', productContainer);
    const addToCartSection = queryFirst('.prices-add-to-cart-actions', productContainer);
    const buyBarAddToCart = queryFirst('.js-buybar-btn');
    const availabilityMsgEl = queryFirst('.availability-msg', productContainer);
    let availabilityValue = '';
    let productDetailsUrl = vgProductDetailsUrl;
    const fullPDPLink = queryFirst('.full-pdp-link', productContainer);
    const wishlistButton = queryFirst('.add-to-wish-list', productContainer);

    if (wishlistButton && hasClass(wishlistButton, 'added-to-wish-list')) {
        removeClass(wishlistButton, 'added-to-wish-list');
        wishlistButton.disabled = false;
    }
    hideStrikeHearts(productContainer);
    if (wishlistDisabled || !isDirectlyPurchasable || isFinalSale) {
        showStrikeHearts(productContainer);
    }

    if (!selectedSizeData || !currentSizeElement) {
        removeClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
        addClass([notifyMeDesc, notifyMeButton, buyBarNotifyMeButton], HIDDEN_CLASS);
        fullPDPLink.href = productDetailsUrl;
        if (!isDirectlyPurchasable) {
            addToCartButton.disabled = true;
            availabilityValue = availabilityMessageTmpl(availabilityMsgEl.dataset.notPurchasable);
            availabilityMsgEl.innerHTML = availabilityValue;
        } else {
            addToCartButton.disabled = false;
        }
        return;
    }

    const { isNotifyMeEnabled, ID, forceOutOfStock, variantProductDetailsUrl, isFinalSale: isFinalSaleVariant, isDirectlyPurchasable: isDirectlyPurchasableVariant, wishlistDisabled: wishlistDisabledVariant } = selectedSizeData;
    productDetailsUrl = variantProductDetailsUrl;
    const { productInventory } = quickViewInfo;
    const { variants } = productInventory;
    const inventoryData = variants[ID];
    const { message, availabilityStatus, isLowInventory } = inventoryData;
    const selectedColorName = queryFirst('.selected-swatch-name').textContent;

    if (!isDirectlyPurchasable) {
        availabilityValue = availabilityMessageTmpl(availabilityMsgEl.dataset.notPurchasable);
    } else if (availabilityStatus !== IN_STOCK || isLowInventory) {
        availabilityValue = availabilityMessageTmpl(message);
    }
    fullPDPLink.href = productDetailsUrl;

    if (!isDirectlyPurchasable) {
        addToCartButton.disabled = true;
        removeClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
        addClass([notifyMeDesc, notifyMeButton], HIDDEN_CLASS);
    } else if (availabilityStatus !== NOT_AVAILABLE && !forceOutOfStock) {
        addToCartButton.disabled = false;
        removeClass(currentSizeElement, NOT_AVAILABLE_CLASS);
        hideStrikeHearts(productContainer);
    } else {
        addClass(currentSizeElement, NOT_AVAILABLE_CLASS);
        addToCartButton.disabled = true;
        showStrikeHearts(productContainer);
        if (isNotifyMeEnabled) {
            addClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
            removeClass([notifyMeDesc, notifyMeButton, buyBarNotifyMeButton], HIDDEN_CLASS);
        } else {
            removeClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
            addClass([notifyMeDesc, notifyMeButton, buyBarNotifyMeButton], HIDDEN_CLASS);
        }
    }

    availabilityMsgEl.innerHTML = availabilityValue;
    productContainer.dataset.pid = ID;
    productContainer.dataset.wishlistId = ID;
    setWishlistProductId(ID, productContainer);
    const productData = {
        available: !hasClass(currentSizeElement, NOT_AVAILABLE_CLASS),
        isNotifyMeEnabled,
        id: ID,
        formattedPrice,
        forceOutOfStock,
        imageData: ispu
    };
    if (wishlistDisabledVariant || !isDirectlyPurchasableVariant || isFinalSaleVariant) {
        showStrikeHearts(productContainer);
    }
    handleNotifyMe(productData, productContainer);

    // secret sauce integration to update product data
    updateProductData(selectedColorName, selectedSizeValue, standardPrice, price, productContainer);
    handleSize(productContainer);

    $('body').trigger('product:afterQuickViewSizeChange', {
        ID,
        productContainer,
        monetateData: {
            pdpBreadCrumbs: variantGroupData.pdpBreadCrumbs
        }
    });
}

/**
 * This method manages Notify me block on PDP
 * @param {Object} productData - Product data
 * @param {Object} productContainer - Product Container DOM element
 */
function handleNotifyMeBlock(productData, productContainer) {
    const addToCartSection = queryFirst('.prices-add-to-cart-actions', productContainer);
    const notifyMeButton = queryFirst('.js-notify-me-btn', productContainer);
    const notifySuccessBlock = queryFirst('.js-notify-confirm-block', productContainer);
    const notifyForm = queryFirst('.js-notify-form', productContainer);
    const notifyContainer = queryFirst('.js-notify-me-container', productContainer);
    const buyBarAddToCart = queryFirst('.js-buybar-btn');
    const buyBarNotifyMeButton = queryFirst('.js-buybar .notify-me-btn');
    const { available, isNotifyMeEnabled, id, forceOutOfStock, isEarlyAccessProduct, isLoyaltyMember, isTierEligible } = productData;
    // Notify Me block shouldn't be shown for early access products if user is not a tier-eligible loyalty member
    const showNotifyMeButton = !isEarlyAccessProduct || (isLoyaltyMember && isTierEligible);
    if (!available && isNotifyMeEnabled && !forceOutOfStock && showNotifyMeButton) {
        addClass([addToCartSection, buyBarAddToCart, notifySuccessBlock], HIDDEN_CLASS);
        removeClass([notifyMeButton, buyBarNotifyMeButton, notifyForm, notifyContainer], HIDDEN_CLASS);

        if (id) queryFirst('.js-notify-sku', productContainer).value = id;
        const customerEmail = (queryFirst('#notifyEmail') || {}).value;
        if (customerEmail) queryAll('.js-notify-email').forEach(field => (field.value = customerEmail));
    } else {
        removeClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
        addClass([notifyMeButton, buyBarNotifyMeButton], HIDDEN_CLASS);
    }
}

/**
 *
 * @param {string} selectedSizeValue - Selected size value
 * @param {int} selectedColorId - selected color id
 * @param {Object} productContainer - product container html element
 * @param {Object} currentSizeElement - current active size element
 */
function updateProductInfo(selectedSizeValue, selectedColorId, productContainer, currentSizeElement) {
    const masterId = productContainer.dataset.masterid;
    const productInfo = window.productInfo[masterId];
    const variantGroupData = productInfo.variants[selectedColorId];
    const {
        sizes,
        images,
        formattedPrice,
        totalPrice,
        monogramProductPrice,
        standardPrice,
        price,
        mgFlag,
        mgLocs,
        isDirectlyPurchasable,
        wishlistDisabled,
        isFinalSale,
        earlyAccess,
        productHighlightSection,
        productInformativeHighlightSection,
        excludeFromPromotions,
        excludeFromAllPromotions
    } = variantGroupData;
    const ispu = base.updateImageDetails(images.extrasmall);
    const selectedSizeData = sizes[selectedSizeValue];
    let allowWishlist = true;
    let addToCartButton = queryFirst('.add-to-cart', productContainer);

    // set addToCart button element if it is ShopTheLook
    const shopTheLookEl = currentSizeElement && currentSizeElement.closest('.js-shop-the-look');
    if (shopTheLookEl) addToCartButton = queryFirst('.js-add-to-cart-global', shopTheLookEl);

    const monogramBtn = queryFirst('.pdp-monogram-btn', productContainer);
    const ispuButton = queryFirst('.btn-in-store-pickup', productContainer);
    const notifyMeButton = queryFirst('.notify-me-btn', productContainer);
    const buyBarNotifyMeButton = queryFirst('.js-buybar .notify-me-btn', productContainer);
    const notifyMeDesc = queryFirst('.notify-me-desc', productContainer);
    const addToCartSection = queryFirst('.prices-add-to-cart-actions', productContainer);
    const buyBarAddToCart = queryFirst('.js-buybar-btn');
    const availabilityMsgEl = queryFirst('.availability-msg', productContainer);
    let availabilityValue = '';

    if (ispuButton) {
        const pickupImageElement = queryFirst('.pickup-product-img img', productContainer);
        const noImages = queryFirst('.pickup-product-img .no-images', productContainer);
        if (pickupImageElement) {
            if (ispu.length) {
                removeClass(pickupImageElement.parent, 'm-no-images');
                addClass(noImages, HIDDEN_CLASS);
                removeClass(pickupImageElement, HIDDEN_CLASS);
                const { alt, url, srcset } = ispu[0];

                pickupImageElement.setAttribute('src', url);
                pickupImageElement.setAttribute('srcset', srcset);
                pickupImageElement.setAttribute('alt', alt);
            } else {
                addClass(pickupImageElement.parent, 'm-no-images');
                removeClass(noImages, HIDDEN_CLASS);
                addClass(pickupImageElement, HIDDEN_CLASS);
            }
        }
    }

    // update 'product highlight section' (hangtag) on PDP
    const hangtagContainer = queryFirst('.js-hangtag-container', productContainer);
    if (hangtagContainer) hangtagContainer.innerHTML = productHighlightSection || '';

    const informativeHighlightSectionContainer = queryFirst('.js-filter-highlight');
    if (informativeHighlightSectionContainer) {
        if (productInformativeHighlightSection) {
            informativeHighlightSectionContainer.innerHTML = productInformativeHighlightSection;
            initCarousels(queryFirst('.js-filter-highlight'));
            queryAll('.video-component').forEach(videoComponent => {
                if (hasVideos(videoComponent)) {
                    initVideos(videoComponent);
                }
            });
        } else {
            informativeHighlightSectionContainer.innerHTML = '';
        }
    }

    const { variants } = window.productInventory[masterId];

    if (!selectedSizeData || !currentSizeElement) {
        if (ispuButton) {
            ispuButton.disabled = true;
        }
        if (monogramBtn) {
            monogramBtn.disabled = true;
        }

        const allSizesSoldOut = Object.values(sizes).every(size => {
            const variant = variants[size.ID];
            return variant && variant.availabilityStatus === NOT_AVAILABLE;
        });

        const sizeNotifyEnable = Object.entries(sizes).some(([key, size]) => size.isNotifyMeEnabled);

        if (!allSizesSoldOut) {
            removeClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
            addClass([notifyMeDesc, notifyMeButton, buyBarNotifyMeButton], HIDDEN_CLASS);
        } else if (sizeNotifyEnable) {
            addClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
            removeClass([notifyMeDesc, notifyMeButton, buyBarNotifyMeButton], HIDDEN_CLASS);
        }

        if (!isDirectlyPurchasable) {
            addToCartButton.disabled = true;
            availabilityValue = availabilityMessageTmpl(availabilityMsgEl.dataset.notPurchasable);
            if (availabilityMsgEl) availabilityMsgEl.innerHTML = availabilityValue;
            if (ispuButton) {
                ispuButton.disabled = true;
            }
        } else {
            addToCartButton.disabled = false;
        }
        updateEarlyAccessCta(productContainer, earlyAccess);
        return;
    }

    const { isNotifyMeEnabled, ID, forceOutOfStock, promotions, showGWPPromoIcon, isFinalSale: isFinalSaleVariant, isDirectlyPurchasable: isDirectlyPurchasableVariant, wishlistDisabled: wishlistDisabledVariant } = selectedSizeData;

    const inventoryData = variants[ID];
    const { message, availabilityStatus, isLowInventory, flexibleMessage, isBackOrder } = inventoryData;

    // Shipping preference view
    const shippingPreferencesEnabled = isShippingPreferencesViewEnabled();
    let ispuAvailabilityValue = '';
    let ispuLowStockValue = '';
    let ispuVariants;
    let ispuInventoryData;
    let ispuMessage;
    let ispuLowStockMessage;
    let ispuAvailabilityStatus;
    let isISPULowInventory;
    if (shippingPreferencesEnabled && window?.ispuProductInventory?.variants) {
        ispuVariants = window.ispuProductInventory.variants;
        ispuInventoryData = ispuVariants[ID];

        if (ispuInventoryData) {
            ispuMessage = ispuInventoryData.message;
            ispuLowStockMessage = ispuInventoryData.lowStockAvailabilityMessage;
            ispuAvailabilityStatus = ispuInventoryData.availabilityStatus;
            isISPULowInventory = ispuInventoryData.isLowInventory;
        }
    }

    const selectedColorName = queryFirst('.selected-swatch-name').textContent;
    if (!isDirectlyPurchasable) {
        availabilityValue = availabilityMessageTmpl(availabilityMsgEl.dataset.notPurchasable);
    } else {
        if (availabilityStatus !== IN_STOCK || isLowInventory) {
            let flexibleMessageWithLink = flexibleMessage;
            if (flexibleMessage && flexibleMessage.indexOf('{0}') !== -1) {
                const categoryUrl = productContainer.dataset.breadcrumbCategoryUrl;
                if (categoryUrl) {
                    flexibleMessageWithLink = flexibleMessage.replace('{0}', categoryUrl);
                }
            }
            const showSimilarLink = (availabilityStatus === NOT_AVAILABLE || isBackOrder) && flexibleMessage;
            if (showSimilarLink) {
                availabilityValue = availabilityMessageOOS(message, flexibleMessageWithLink);
            } else if (availabilityStatus !== PREORDER) {
                availabilityValue = availabilityMessageTmpl(message);
            }
            if (isLowInventory) addClass(currentSizeElement, SHIP_TO_LOW_INVENTORY_CLASS);
        }

        // Shipping preference view
        if (ispuAvailabilityStatus && (ispuAvailabilityStatus !== IN_STOCK || isISPULowInventory)) {
            ispuAvailabilityValue = ispuAvailabilityMessageTmpl(ispuMessage);
            ispuLowStockValue = ispuLowStockMessage ? ispuLowStockMessageTmpl(ispuLowStockMessage) : '';
        }
    }

    const pdpShippingPaymentPromo = queryFirst('.js-shipping-payment', productContainer);
    const preorderMessageEl = queryFirst('.js-preorder-message', productContainer);
    const loyaltyProfile = getNestedValue(window, 'lillyUtils.profile') || {};
    const { isLoyaltyProgramMember, isLoyaltyEnabled } = loyaltyProfile;

    if (!isDirectlyPurchasable) {
        addToCartButton.disabled = true;
        removeClass([addToCartSection, buyBarAddToCart, pdpShippingPaymentPromo], HIDDEN_CLASS);
        addClass([notifyMeDesc, notifyMeButton, buyBarNotifyMeButton], HIDDEN_CLASS);
    } else if (availabilityStatus !== NOT_AVAILABLE && !forceOutOfStock && !isBackOrder) {
        addToCartButton.disabled = false;
        removeClass(currentSizeElement, NOT_AVAILABLE_CLASS);
        removeClass([addToCartButton, pdpShippingPaymentPromo], HIDDEN_CLASS);
        allowWishlist = true;

        if (isLoyaltyEnabled && earlyAccess.isEarlyAccessProduct) {
            if (base.isTierEligibleForEarlyAccess(earlyAccess)) {
                removeClass(addToCartButton, HIDDEN_CLASS);
            } else {
                addClass(addToCartButton, HIDDEN_CLASS);
            }
        }
    } else {
        addClass(currentSizeElement, NOT_AVAILABLE_CLASS);
        addClass([pdpShippingPaymentPromo], HIDDEN_CLASS);
        addToCartButton.disabled = true;
        allowWishlist = false;
    }

    if (preorderMessageEl) {
        if (availabilityStatus === PREORDER) {
            addClass(currentSizeElement, 'pre-order');
            preorderMessageEl.innerHTML = availabilityMessagePreorder(message);
        } else {
            preorderMessageEl.innerHTML = '';
        }
    }

    if (shippingPreferencesEnabled) {
        $body.trigger('product:inventoryStatus', {
            shipToAddressAvailabilityStatus: availabilityStatus,
            inStorePickUpAvailabilityStatus: ispuAvailabilityStatus || NOT_AVAILABLE,
            isStorePickUpLowInventory: isISPULowInventory,
            inStorePickUpAvailabilityMessage: ispuAvailabilityValue,
            inStorePickUpLowStockMessage: ispuLowStockValue,
            productContainer
        });
    }
    if (availabilityMsgEl) availabilityMsgEl.innerHTML = availabilityValue;
    queryFirst('.js-add-product-errors', productContainer).innerHTML = '';
    productContainer.dataset.pid = ID;
    queryFirst('.product-id', productContainer).textContent = ID;
    setWishlistProductId(ID, productContainer);
    productContainer.dataset.wishlistId = ID;
    const productData = {
        available: !hasClass(currentSizeElement, NOT_AVAILABLE_CLASS),
        isNotifyMeEnabled,
        isEarlyAccessProduct: !!earlyAccess.isEarlyAccessProduct,
        isLoyaltyMember: isLoyaltyEnabled && isLoyaltyProgramMember,
        isTierEligible: base.isTierEligibleForEarlyAccess(earlyAccess),
        id: ID,
        formattedPrice,
        forceOutOfStock,
        imageData: ispu
    };

    handleNotifyMeBlock(productData, productContainer);
    if (!isDirectlyPurchasable) {
        if (ispuButton) {
            ispuButton.disabled = true;
        }
    } else if (ispuButton) {
        ispuButton.disabled = false;
        ispuButton.dataset.pid = ID;

        queryFirst('.pickup-price').textContent = formattedPrice.replace('.00', '');
        queryFirst('.pickup-color .selected-color').textContent = selectedColorName;

        const pickupSize = queryFirst('.pickup-size');
        const sizeSelected = queryFirst('.size-card .size-btn.selected');
        if (sizeSelected) {
            queryFirst('.selected-size', pickupSize).textContent = sizeSelected.dataset.attrValue;
        }
        removeClass(queryFirst('.pdp-attribute-name', productContainer), 'm-error');
    }

    const product = {};
    if (mgFlag && mgLocs && mgLocs.length > 0) {
        const monogramImages = images.monogram || [];
        let url = '';
        let srcset = '';
        let sources = '';
        let breakpoints = '';
        if (monogramImages.length) {
            const updatedImageData = base.updateImageDetails(monogramImages)[0];
            url = updatedImageData.url;
            srcset = updatedImageData.srcset;
            sources = updatedImageData.sources;
            breakpoints = updatedImageData.breakpoints;
        }
        const monogramObject = {
            monogramProductID: ID,
            monogramImageURL: url,
            monogramImageSrcSetURL: srcset,
            monogramImageSources: sources,
            monogramImageBreakpoits: breakpoints,
            monogramLocations: mgLocs,
            monogramSelectedColor: selectedColorName,
            monogramSelectedSize: selectedSizeValue,
            productPrice: formattedPrice,
            monogramProductPrice,
            totalPrice: totalPrice
        };
        product.monogramObject = monogramObject;
    }

    // secret sauce integration to update product data
    updateProductData(selectedColorName, selectedSizeValue, standardPrice, price, productContainer);
    handleSize(productContainer);
    $('body').trigger('product:afterSizeChange', {
        data: {
            product
        },
        productSizeData: selectedSizeData,
        allowWishlist,
        ID,
        productContainer
    });
    if (monogramBtn) {
        monogramBtn.disabled = !(availabilityStatus !== NOT_AVAILABLE && !forceOutOfStock && !hasClass(monogramBtn, HIDDEN_CLASS) && isDirectlyPurchasable);
    }

    // update promotion messages display for selected variation
    updatePromoBlockContent(promotions, productContainer, excludeFromPromotions, excludeFromAllPromotions, showGWPPromoIcon);

    if (wishlistDisabled) {
        showStrikeHearts(productContainer);
    }

    // pick new promotion popover elements
    initPopoverPromotions();
    initPopoverCloseSelector();
    initPopoverWishList();
    initPopoverClose();
    updateEarlyAccessCta(productContainer, earlyAccess);
}

function initCustomZoom() {
    queryAll('.js-swiper-modal').forEach(handleProductImageZoom);
}


const init = () => {
    initCustomZoom();

    // Enable keyboard navigation and roving tabindex for PDP color/size radiogroups
    initRadioGroupKeyboardNav(
        '.pdp-container .color-attribute[role="radio"]',
        ['.pdp-container .color-swatches[role="radiogroup"]', '.pdp-container .color-container']
    );
    initRadioGroupKeyboardNav(
        '.pdp-container .size-btn[role="radio"]',
        ['.pdp-container .size-container[role="radiogroup"]', '.pdp-container .size-container']
    );

    // Normalize initial PDP color radiogroup so only one swatch is tabbable
    const pdpContainer = queryFirst('.pdp-container');
    if (pdpContainer) {
        const colorGroup = queryFirst('.color-swatches[role="radiogroup"]', pdpContainer) || pdpContainer;
        normalizeRadioGroup(colorGroup, '.color-attribute[role="radio"]', {
            selectedClass: SELECTED_CLASS
        });
    }

    $('body').on('product:handleImageZoom', initCustomZoom);

    $('.js-pdp-lightbox-modal')
        .on('shown.bs.modal', e => {
            const dialog = e.currentTarget;
            const pdpModalCarouselEl = queryFirst('.js-swiper-modal', dialog);
            const slideIndex = e.relatedTarget && e.relatedTarget.hasAttribute('data-index') ? e.relatedTarget.dataset.index : 0;

            if (pdpModalCarouselEl.swiper && e.relatedTarget) {
                pdpModalCarouselEl.swiper.update();
                pdpModalCarouselEl.swiper.enable();
                pdpModalCarouselEl.swiper.scrollbar.updateSize();
                pdpModalCarouselEl.swiper.setTranslate();
                pdpModalCarouselEl.swiper.slideTo(slideIndex);
                zoomedState = false;
            }
        })
        .on('hidden.bs.modal', e => {
            const dialog = e.currentTarget;
            const pdpModalCarouselEl = queryFirst('.js-swiper-modal', dialog);

            if (pdpModalCarouselEl.swiper) {
                $('.swiper-slide-active img', pdpModalCarouselEl).trigger('zoom:imageChange');
                $('.zoomed').removeClass('zoomed');
                pdpModalCarouselEl.swiper.disable();
                zoomedState = false;
            }
        });
};

/**
 * Toogle Size chart and select needed category
 * @param {Object} $this - Size chart link JQUERY element
 * @param {Object} $prodSizeChart) - Size chart window element
 */
function toogleActiveSizeChartTab($this, $prodSizeChart) {
    const $lpSlideout = $('.lp-sizechart');
    const { sizefamily: activeCategoryVal, defaulttext: defaultText } = $this.data();
    const $activeCategoryEl = $prodSizeChart.find(`a[href="#${activeCategoryVal}-size"]`);
    const $lpSizechartTitle = $prodSizeChart.find('.lp-sizechart-category-btn');
    $lpSizechartTitle.focus();
    $activeCategoryEl.tab('show');
    $lpSizechartTitle.text($activeCategoryEl.text().length ? $activeCategoryEl.text() : defaultText);
    $prodSizeChart.addClass('active');
}

let isBound = false;

export default {
    init: init,

    availability: base.availability,

    addToCart: base.addToCart,

    scrollPageToReviews: function () {
        if (!isBound) {
            document.addEventListener('click', (e) => {
                const host = e.target.closest?.('.bv_rating_summary_buttons_container');
                if (!host) return;

                scrollToSection('#bazaarvoiceReviews', e);
            }, true);

            // ADA: Space and Enter (both main and numpad) scroll to reviews instead of opening the popup
            document.addEventListener('keydown', (e) => {
                const { key, keyCode } = e;

                const isEnter = key === EVENT_KEY_ENTER || keyCode === KEYCODE_ENTER;
                const isSpace = key === EVENT_KEY_SPACE || keyCode === KEYCODE_SPACE;

                if (!isEnter && !isSpace) return;

                const btn = document.activeElement;
                if (!(btn instanceof Element)) return;

                // only BV stars button
                if (!btn.matches('button.bv_main_rating_button') || !queryFirst('.bv_stars_component_container', btn)) return;

                scrollToSection('#bazaarvoiceReviews', e);
            }, true);

            isBound = true;
        }
    },

    handleBuyBar: function () {
        const buyBarEl = queryFirst('.js-buybar');

        buyBarSyncIds();

        $body.on('product:afterAddToCart', (e, data) => {
            const buybarInProgress = queryFirst('.js-buybar-btn.m-progress');

            if (data?.error) {
                if (buybarInProgress) {
                    removeClass(buybarInProgress, 'm-progress');
                }
                return;
            }

            buyBarSyncIds();

            const variantId = queryFirst('.pdp-container .size-btn.selected')?.dataset?.variationId
                || queryFirst('.pdp-container .product-id')?.textContent;
            if (variantId && !cartVariantIds.includes(variantId)) {
                cartVariantIds.push(variantId);
            }

            if (buybarInProgress) {
                removeClass(buybarInProgress, 'm-progress');
                addClass(buybarInProgress, 'm-done');
            }

            buyBarUpdateState();
        });

        $body.on('miniCart:show', () => {
            buyBarSyncIds();
            buyBarUpdateState();
        });

        $body.on('click', '.remove-product-btn', e => {
            const { pid } = e.currentTarget.dataset;
            const index = cartVariantIds.indexOf(pid);
            if (index > -1) {
                cartVariantIds.splice(index, 1);
            }
            buyBarUpdateState();
        });

        if (window.matchMedia('(max-width: 767px)').matches && buyBarEl) {
            const count = parseInt(queryFirst('.minicart-quantity')?.textContent, 10);
            const actionUrl = queryFirst('.minicart-toggle')?.dataset?.actionUrl;
            if (count && actionUrl) {
                fetch(actionUrl)
                    .then(res => res.text())
                    .then(html => {
                        buyBarSyncHtml(html);
                        buyBarUpdateState();
                    })
                    .catch(() => {
                        buyBarUpdateState();
                    });
            }

            // Show on page load — bar is visible until the ATC button scrolls into view
            removeClass(buyBarEl, HIDDEN_CLASS);

            const observer = new IntersectionObserver(
                entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            addClass(buyBarEl, HIDDEN_CLASS);
                        } else {
                            removeClass(buyBarEl, HIDDEN_CLASS);
                        }
                    });
                },
                {
                    rootMargin: '-40px 0px -40px 0px'
                }
            );

            queryAll('.js-buybar-breakpoint').forEach(el => {
                observer.observe(el);
            });

            queryFirst('.js-buybar-btn', buyBarEl).addEventListener('click', e => {
                e.preventDefault();
                const buybarBtn = e.currentTarget;

                if (hasClass(buybarBtn, 'js-buybar-select') || !hasClass(buybarBtn, 'selected')) {
                    queryFirst('.row[data-attr="size"]').scrollIntoView();
                    return;
                }

                removeClass(buybarBtn, 'm-done');
                addClass(buybarBtn, 'm-progress');

                const addToCartBtn = queryFirst('.pdp-container .add-to-cart');
                if (addToCartBtn) {
                    addToCartBtn.click();
                } else {
                    removeClass(buybarBtn, 'm-progress');
                }
            });
        }
    },

    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            const { container } = response;
            const { id, variationAttributes } = response.data.product;
            if ($('.product-detail>.bundle-items').length) {
                container.data('pid', id);
                container.find('.product-id').text(id);
            } else if ($('.product-set-detail').eq(0)) {
                container.data('pid', id);
                container.find('.product-id').text(id);
            } else {
                $('.product-id').text(id);
                $('.product-detail:not(".bundle-item")').data('pid', id);
            }
            updateSelectedSwatchProductName(variationAttributes, container);
            $('body').trigger('product:handleImageZoom');
        });
    },

    selectSizeAttribute: function () {
        $(document).on('click', '.product-quickview .size-btn', function (e) {
            e.preventDefault();
            if (!hasClass(this, 'selected')) {
                const $productContainer = $(this).closest('.product-detail');
                const url = this.dataset.attrUrl;
                if ($productContainer.hasClass('cached-quick-view')) {
                    const productContainer = this.closest('.product-detail');
                    const selectedColorElement = queryFirst('.color-attribute .swatch-circle.selected', productContainer);
                    const selectedColorId = selectedColorElement.dataset.attrValue;
                    const selectedSizeValue = this.dataset.attrValue;
                    onSizeChangeHandler.apply(this, [productContainer, selectedSizeValue]);
                    updateProductInfo(selectedSizeValue, selectedColorId, productContainer, this);
                } else {
                    base.attributeSelect(url, $productContainer, this);
                }
            }
        });
        $('body').on('product:quickViewAttributeChange', (e, response) => {
            const selectedSizeElement = queryFirst('.product-quickview.cached-quick-view .size-btn.selected');
            const selectedValue = selectedSizeElement ? selectedSizeElement.dataset.attrValue : '';
            updateQuickViewProductInfo(selectedValue, response.variantGroupId, response.container[0], selectedSizeElement);
        });
    },
    afterAttributeSelect: function () {
        $body.on('product:afterAttributeSelect', (event, response) => {
            const responseContainer = response.container[0];

            // Bonus product chooser has its own flow (updateGwpElements in product/base.js).
            // PDP-specific markup is absent here and would crash this handler.
            if (hasClass(responseContainer, 'bonus-product-item')
                || responseContainer.closest('.choice-of-bonus-product')) {
                return;
            }

            const { selectedSizeElement } = response;
            const { product } = response.data;
            const { id, readyToOrder, available, forceOutOfStock, price, wishListID, images, isDirectlyPurchasable, wishlistDisabled, activeData, earlyAccess, isNotifyMeEnabled } = product;
            const { extrasmall: ispu } = images;
            const addToCartButton = queryFirst('.add-to-cart', responseContainer);
            const addToCartSection = queryFirst('.prices-add-to-cart-actions', responseContainer);
            const notifyContainer = queryFirst('.js-notify-me-container', responseContainer);
            const notifyMeButton = queryFirst('.notify-me-btn', responseContainer);
            const notifyMeDesc = queryFirst('.js-notify-me-desc', responseContainer);

            const pdpAttributes = queryFirst('.pdp-attributes', responseContainer);
            const sizeElements = queryAll('.size-btn', pdpAttributes);
            const isBonusProduct = hasClass(responseContainer, 'bonus-product-item');
            responseContainer.dataset.pid = id;
            responseContainer.dataset.wishlistId = wishListID;
            setWishlistProductId(wishListID, responseContainer);
            let ssSize = 'unkown';
            const allSizesSoldOut = sizeElements.every(sizeElement => hasClass(sizeElement, NOT_AVAILABLE_CLASS));
            if (allSizesSoldOut) {
                addClass([addToCartSection], HIDDEN_CLASS);
                if (isNotifyMeEnabled) {
                    removeClass([notifyMeButton, notifyContainer, notifyMeDesc], HIDDEN_CLASS);
                }
            } else {
                removeClass([addToCartSection], HIDDEN_CLASS);
                addClass([notifyMeButton, notifyContainer, notifyMeDesc], HIDDEN_CLASS);
            }
            if (hasClass(responseContainer, 'product-quickview') && addToCartButton) {
                addToCartButton.disabled = false;
            }
            if (selectedSizeElement && !isBonusProduct) {
                ssSize = selectedSizeElement.dataset.attrValue;
                removeClass(queryAll('.size-btn', responseContainer), 'selected');
                addClass(selectedSizeElement, 'selected');
                const sizeCard = selectedSizeElement.closest('.size-card');
                const selectedSize = queryFirst('.selected-size', sizeCard);
                if (selectedSize) {
                    const sizeSeparator = queryFirst('.size-seperator', sizeCard);
                    selectedSize.textContent = selectedSizeElement.dataset.attrValue;
                    removeClass([sizeSeparator, selectedSize], HIDDEN_CLASS);
                }
                const sizeContainer = selectedSizeElement.closest('.size-container');
                const assistiveElements = queryAll('.selected-assistive-text', sizeContainer);
                assistiveElements?.forEach(eachElement => {
                    if (eachElement.textContent.includes(eachElement.dataset.outOfStock)) {
                        eachElement.textContent = eachElement.dataset.outOfStock;
                    } else {
                        eachElement.textContent = '';
                    }
                });
                const assistiveElementOfSelected = queryFirst('.selected-assistive-text', selectedSizeElement.closest('.size-list'));
                const { selectedText, outOfStock } = assistiveElementOfSelected.dataset;
                if (hasClass(selectedSizeElement, NOT_AVAILABLE_CLASS)) {
                    assistiveElementOfSelected.textContent = outOfStock;
                } else {
                    assistiveElementOfSelected.textContent = selectedText;
                }
                if (addToCartButton) {
                    const restrictedFromOrder = !readyToOrder || !available || forceOutOfStock;
                    addToCartButton.disabled = restrictedFromOrder;
                    if (restrictedFromOrder) {
                        showStrikeHearts(responseContainer);
                    } else {
                        hideStrikeHearts(responseContainer);
                    }
                }
                const salesPrice = price.type === 'range' ? price.min.sales : price.sales;
                const loyaltyProfile = getNestedValue(window, 'lillyUtils.profile') || {};
                const { isLoyaltyProgramMember, isLoyaltyEnabled } = loyaltyProfile;
                const productData = {
                    available: available,
                    isNotifyMeEnabled: !!isNotifyMeEnabled,
                    isEarlyAccessProduct: !!earlyAccess.isEarlyAccessProduct,
                    isLoyaltyMember: isLoyaltyEnabled && isLoyaltyProgramMember,
                    isTierEligible: base.isTierEligibleForEarlyAccess(earlyAccess),
                    id: id,
                    formattedPrice: salesPrice.formatted,
                    forceOutOfStock,
                    imageData: ispu
                };

                const quickviewContainer = selectedSizeElement.closest('.product-quickview');
                if (quickviewContainer) {
                    const addToCartSection = queryFirst('.prices-add-to-cart-actions', responseContainer);
                    const notifyMeButton = queryFirst('.notify-me-btn', responseContainer);
                    const notifyMeDesc = queryFirst('.notify-me-desc', responseContainer);
                    const availabilityMessageEl = queryFirst('.product-availability', responseContainer);
                    handleNotifyMe(productData, quickviewContainer);
                    const updateCartButton = queryFirst('.update-cart-product-global', quickviewContainer);
                    if (updateCartButton) {
                        const { giftWrapAvailableFlag } = product;
                        updateCartButton.dataset.giftWrapAvailable = giftWrapAvailableFlag;
                    }
                    if (isDirectlyPurchasable === false) {
                        removeClass(addToCartSection, HIDDEN_CLASS);
                        if (availabilityMessageEl) {
                            removeClass(availabilityMessageEl, HIDDEN_CLASS);
                        }
                        addClass([notifyMeDesc, notifyMeButton], HIDDEN_CLASS);
                    }
                } else {
                    handleNotifyMeBlock(productData, responseContainer);
                }

                const ispuButton = queryFirst('.btn-in-store-pickup', responseContainer);
                if (ispuButton) {
                    ispuButton.dataset.pid = id;
                    ispuButton.disabled = false;
                    const pickupImageElement = queryFirst('.pickup-product-img img', responseContainer);
                    const noImages = queryFirst('.pickup-product-img .no-images', responseContainer);
                    if (pickupImageElement) {
                        if (ispu && ispu.length) {
                            removeClass(pickupImageElement.parent, 'm-no-images');
                            addClass(noImages, HIDDEN_CLASS);
                            removeClass(pickupImageElement, HIDDEN_CLASS);
                            const { alt, url, srcset } = ispu[0];

                            pickupImageElement.setAttribute('src', url);
                            pickupImageElement.setAttribute('srcset', srcset);
                            pickupImageElement.setAttribute('alt', alt);
                        } else {
                            addClass(pickupImageElement.parent, 'm-no-images');
                            removeClass(noImages, HIDDEN_CLASS);
                            addClass(pickupImageElement, HIDDEN_CLASS);
                        }
                    }
                    queryFirst('.pickup-product-name', responseContainer).textContent = product.productName;
                    queryFirst('.pickup-price').textContent = product.price.sales.formatted.replace('.00', '');
                    const selectedSwatchName = queryFirst('.selected-swatch-name', responseContainer);
                    if (selectedSwatchName) {
                        queryFirst('.pickup-color .selected-color', responseContainer).textContent = selectedSwatchName.textContent;
                    }
                    const pickupSize = queryFirst('.pickup-size', responseContainer);
                    const sizeSelected = queryFirst('.size-card .size-btn.selected', responseContainer);
                    if (sizeSelected) {
                        queryFirst('.selected-size', pickupSize).textContent = sizeSelected.dataset.attrValue;
                    }
                }
            }
            if (hasClass(responseContainer, 'product-quickview') && isDirectlyPurchasable === false) {
                const addToCartSection = queryFirst('.prices-add-to-cart-actions', responseContainer);
                const notifyMeButton = queryFirst('.notify-me-btn', responseContainer);
                const notifyMeDesc = queryFirst('.notify-me-desc', responseContainer);
                const availabilityMessageEl = queryFirst('.product-availability', responseContainer);
                removeClass(addToCartSection, HIDDEN_CLASS);
                if (addToCartButton) {
                    addToCartButton.disabled = true;
                }
                if (availabilityMessageEl) {
                    removeClass(availabilityMessageEl, HIDDEN_CLASS);
                }
                addClass([notifyMeDesc, notifyMeButton], HIDDEN_CLASS);
            }
            const wishlistButton = queryFirst('.add-to-wish-list', responseContainer);
            if (wishlistButton && hasClass(wishlistButton, 'added-to-wish-list')) {
                removeClass(wishlistButton, 'added-to-wish-list');
                wishlistButton.disabled = false;
                const assistiveText = wishlistButton.getAttribute('data-assistive-text');
                wishlistButton.setAttribute('aria-label', assistiveText);
            }
            if (!hasClass(responseContainer, 'gift-card-main') && !document.getElementById('chooseBonusProductModal')) {
                const ssColorElement = queryFirst('.color-container .color-attribute.selected', responseContainer);
                const ssColor = (ssColorElement && ssColorElement.dataset.attrDisplayvalue) || 'unknown';
                const { type } = price;
                const pricesObject = type === 'range' ? price.min : price;
                const { sales, list } = pricesObject;
                const ssSalesPrice = (sales && sales.value.toString()) || 'unknown';
                const ssPrice = (list && list.value.toString()) || ssSalesPrice;
                updateProductData(ssColor, ssSize, ssPrice, ssSalesPrice, responseContainer);
                if (ssSize === 'unknown') {
                    handleColor(responseContainer);
                } else {
                    handleSize(responseContainer);
                }
            }
            if (selectedSizeElement) {
                const productSetModal = selectedSizeElement.closest('#productSetModal');
                if (productSetModal) {
                    const addAllToToteButton = queryFirst('.add-to-cart-global', productSetModal);
                    if (addAllToToteButton) {
                        const productsAvailability = queryAll('.product-availability', productSetModal).filter(item => !hasClass(item.closest('.product-detail'), 'hidden-set'));
                        const numberOfProducts = productsAvailability.length;

                        // Check to enable add to tote button, if atleast one product exists
                        let enable = true;
                        if (!numberOfProducts) {
                            enable = false;
                        }
                        addAllToToteButton.disabled = !enable;
                    }
                }
            }

            if (wishlistDisabled) {
                showStrikeHearts(responseContainer);
            }
            $.spinner().stop();
        });
    },
    selectPdpSizeAttribute: function () {
        $(document).on('click', '.pdp-container .size-btn, .product-set-item .size-btn', function (e) {
            const { target } = e;

            if (target.closest('.js-product-tile')) {
                return;
            }

            e.preventDefault();
            // return, if an unavailable size was clicked inside ShopTheLook
            const shopTheLookEl = queryFirst('.modal.show .js-shop-the-look');
            let isInsideShopTheLook = shopTheLookEl?.contains(target);
            if (hasClass(this, NOT_AVAILABLE_CLASS) && isInsideShopTheLook) return;

            const productContainer = this.closest('.product-detail');
            const selectedColorElement = queryFirst('.color-attribute .swatch-circle.selected', productContainer);
            const selectedColorId = selectedColorElement.dataset.attrValue;
            const selectedSizeValue = this.dataset.attrValue;
            onSizeChangeHandler.apply(this, [productContainer, selectedSizeValue]);
            updateProductInfo(selectedSizeValue, selectedColorId, productContainer, this);
            $body.trigger('product:pdpSizeSelected', {
                selectedColorElement,
                selectedSizeElement: this,
                productContainer
            });

            // additional actions if it is ShopTheLook
            if (isInsideShopTheLook) {
                const jsAttributeEl = target.closest('.js-attribute');
                const sizeElements = queryAll('.size-btn', jsAttributeEl);
                if (sizeElements.length > 1) {
                    queryFirst('.js-select-size-input', jsAttributeEl).checked = true;
                }
                // enable/disable addToCartButton
                enableAddAllToToteButton(shopTheLookEl);
                addClass(queryFirst('.js-size-selector', jsAttributeEl), HIDDEN_CLASS);
                removeClass(queryAll('.js-edit-size-btn, .js-selected-size-block', jsAttributeEl), HIDDEN_CLASS);
            }
        });
        $('body').on('product:afterAttributeChange', (e, response) => {
            const selectedSizeElement = queryFirst('.pdp-container .pdp-attributes .size-btn.selected');
            const selectedValue = selectedSizeElement ? selectedSizeElement.dataset.attrValue : '';
            updateProductInfo(selectedValue, response.variantGroupId, response.container[0], selectedSizeElement);
        });

        const pdpContainer = queryFirst('.pdp-container');
        const pdpAttributes = queryFirst('.pdp-attributes', pdpContainer);
        const swatchEl = queryFirst('button.color-attribute .swatch-circle.selected', pdpAttributes);

        if (swatchEl) {
            const masterId = hasClass(pdpContainer, 'product-set-detail') ? queryFirst('.js-product-set-item').dataset.masterid : pdpContainer.dataset.masterid;
            const sizeElements = queryAll('.size-btn', pdpAttributes);

            if (sizeElements.length) {
                if (sizeElements.length === 1) {
                    queryFirst('.size-btn', pdpAttributes).click();
                } else {
                    const selectedSizeEl = queryFirst('.size-btn.selected', pdpAttributes);

                    if (selectedSizeEl) {
                        selectedSizeEl.click();
                    }
                }

                if (!queryFirst('.size-btn.not-purchasable', pdpAttributes)) {
                    const allSizesSoldOut = sizeElements.every(sizeElement => hasClass(sizeElement, NOT_AVAILABLE_CLASS));
                    const productInfoVariants = window.productInfo[masterId].variants;
                    const selectedColorId = swatchEl.dataset.attrValue;
                    const sizeNotifyEnable = Object.entries(productInfoVariants[selectedColorId].sizes).some(([key, size]) => size.isNotifyMeEnabled);
                    const addToCartSection = queryFirst('.prices-add-to-cart-actions', pdpContainer);
                    const buyBarAddToCart = queryFirst('.js-buybar-btn');

                    // In case if all product sizes sold out and Notify me box not showed
                    // we hide this variation from swatches and select first color variation that have
                    // available sizes
                    if (allSizesSoldOut) {
                        removeClass(swatchEl, 'selectable');

                        const allSelectableSwatches = queryAll('button.color-attribute .swatch-circle.selectable', pdpAttributes);

                        if (allSelectableSwatches.length && !sizeNotifyEnable) {
                            // Hide the selected swatch because it's out of stock
                            addClass(swatchEl.closest('li'), HIDDEN_CLASS);
                            allSelectableSwatches[0].click();
                        }

                        if (sizeNotifyEnable) {
                            addClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
                            // Show Notify me box if it is enabled for this variation
                            const notifyContainer = queryFirst('.js-notify-me-container', pdpContainer);
                            const notifyMeButton = queryFirst('.notify-me-btn', pdpContainer);
                            const notifyMeDesc = queryFirst('.js-notify-me-desc', pdpContainer);
                            removeClass([notifyMeButton, notifyContainer, notifyMeDesc], HIDDEN_CLASS);
                        }
                    } else {
                        removeClass([addToCartSection, buyBarAddToCart], HIDDEN_CLASS);
                    }
                }
            }
        }

        $('body').on('click', '.js-notify-me-btn', function (e) {
            const productContainer = this.closest('.pdp-container');
            toggleSelectSizeInfo(productContainer);
            if (!queryFirst('.size-btn.selected', productContainer)) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        });
    },

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes').empty().html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description').removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content').empty().html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description').addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details').removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content').empty().html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details').addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function (e, target) {
            if ((target && hasClass(target, 'js-buybar-btn')) || queryFirst('.js-buybar-btn.m-progress')) {
                return;
            }

            const isPdpAddToCart = e.type === 'product:beforeAddToCart'
                && (queryFirst('.page[data-action="Product-Show"]') || queryFirst('.pdp-container'))
                && !queryFirst('.cart-container');

            if (isPdpAddToCart) {
                return;
            }

            const productSetModal = document.getElementById('productSetModal');
            const quickViewModal = document.getElementById('quickViewModal');
            const monogramModal = document.getElementById('monogram-modal');
            if (productSetModal && hasClass(productSetModal, 'show')) {
                $(productSetModal).spinner().start();
            } else if (quickViewModal && hasClass(quickViewModal, 'show')) {
                $(quickViewModal).spinner().start();
            } else if (!(monogramModal && hasClass(monogramModal, 'show'))) {
                $.spinner().start();
            }
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer).attr('data-ready-to-order', response.product.readyToOrder).attr('data-available', response.product.available);

            var availabilityValue = '';
            var availabilityMessages = response.product.availability.messages;
            if (response.product.readyToOrder) {
                availabilityMessages.forEach(message => {
                    availabilityValue += availabilityMessageTmpl(message);
                });
            }

            const container = response.$productContainer && response.$productContainer[0];
            const variantId = response.product && response.product.id;
            const masterId = container && container.dataset && container.dataset.masterid;
            const inventory = masterId && variantId && window.productInventory && window.productInventory[masterId];
            const variantData = inventory && inventory.variants && inventory.variants[variantId];
            let flexibleMessage = variantData && variantData.flexibleMessage;
            const isOOS = variantData && (variantData.availabilityStatus === NOT_AVAILABLE || variantData.isBackOrder);
            if (isOOS && flexibleMessage) {
                const containerEl = response.$productContainer && (response.$productContainer[0] || response.$productContainer);
                const categoryUrl = containerEl && containerEl.dataset?.breadcrumbCategoryUrl;
                if (categoryUrl && flexibleMessage.indexOf('{0}') !== -1) {
                    flexibleMessage = flexibleMessage.replace('{0}', categoryUrl);
                }
                const message = variantData.message || availabilityMessages[0] || '';
                availabilityValue = availabilityMessageOOS(message, flexibleMessage);
            }

            $('.availability-msg', response.$productContainer).empty().html(availabilityValue);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability').data('ready-to-order', allReady).data('available', allAvailable);

                $('.global-availability .availability-msg')
                    .empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        const $prodSizeChart = $('.size-chart-collapsible');
        const $sizeguideSheet = $('#sizeguide-modal');
        const $dialog = $sizeguideSheet.find('.modal-dialog');

        $body.off('click.sizeChart', '.js-size-chart-link');
        $body.on('click.sizeChart', '.js-size-chart-link', function (e) {
            const element = $(this);
            const url = element.data('href');
            const $spinner = $dialog.spinner();

            $spinner.start();

            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    },
                    complete: function () {
                        toogleActiveSizeChartTab(element, $prodSizeChart);
                    }
                });
            } else {
                toogleActiveSizeChartTab(element, $prodSizeChart);
            }

            $spinner.stop();
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    renderSizeElements: base.renderSizeElements,
    handleEarlyAccessPLPLockIcon: base.handleEarlyAccessPLPLockIcon(),
    initLoyaltyPointsVisibility: base.initLoyaltyPointsVisibility(),
    handleEarlyAccessLockIcon: function () {
        const productContainers = queryAll('.js-product-set-item');

        // forEach passes (item, index, array) so its 2nd param `earlyAccess`,
        // receives the array index instead. That's falsy only for index 0, so every
        // container after the first would skip its early access lookup and break EA gating.
        (productContainers.length ? productContainers : [queryFirst('.pdp-container')]).forEach(container => updateEarlyAccessCta(container));
    },
    handleOfflineProduct: function () {
        const offlineContainerEl = queryFirst('.offline-product-detail');
        if (offlineContainerEl) {
            const pid = offlineContainerEl.dataset.pid;
            const availabilityStatus = getNestedValue(window, `productInventory.variants[${pid}].availabilityStatus`);
            if (availabilityStatus === IN_STOCK) {
                const { search: currentSearch } = window.location;
                const TS_PARAM = 'timestamp=';
                if (!currentSearch.includes(TS_PARAM)) {
                    window.location.search = (currentSearch ? currentSearch + '&' : '') + TS_PARAM + new Date().getTime();
                }
            }
        }
    },
    handlePdpNonEarlyAccessLoyalty: function () {
        // Sign in/Create account modal for non-early access product

        const signInCreateAccountModal = queryFirst('#account-sheet');
        const loyaltyEnrollNowModal = queryFirst('#loyalty-enrollnow-modal');
        const pdpSignInCreateAccountButton = queryAll('.pdp-non-early-access-login');
        const earlyAccessSignInInfo = queryAll('.early-access-sign-info');
        const pdpSignInInfo = queryFirst('.pdp-sign-in-info');
        const earlyAccessSignInText = queryFirst('.early-access-sign-in-text');
        const joinButton = queryFirst('.join-now-button');
        const earlyAccessWelcomeCta = queryFirst('.loyalty-early-access-welcome-cta');
        const loyaltyWelcomeDialog = queryFirst('#loyalty-welcome-popup');
        const $nonEarlyAccessLogin = $('.pdp-non-early-access-login');

        $nonEarlyAccessLogin.on('click', function () {
            const button = this;
            // return focus to trigger after modal is closed
            $(signInCreateAccountModal).one('hidden.bs.modal', () => button.focus());
        });

        if (joinButton) {
            joinButton.addEventListener('click', e => {
                e.preventDefault();
                $(loyaltyEnrollNowModal).modal('show');
                const welcomeDialogEarlyAccessMsgEl = queryAll('.js-loyalty-welcome-early-access');
                const welcomeDialogMsgEl = queryAll('.js-loyalty-welcome-msg');
                addClass(welcomeDialogMsgEl, HIDDEN_CLASS);
                removeClass(welcomeDialogEarlyAccessMsgEl, HIDDEN_CLASS);
            });
        }
        if (earlyAccessWelcomeCta) {
            earlyAccessWelcomeCta.addEventListener('click', function () {
                location.reload();
            });
        }
        $(loyaltyWelcomeDialog)
            .off('hidden.bs.modal.loyaltyWelcomeReload')
            .on('hidden.bs.modal.loyaltyWelcomeReload', function () {
                location.reload();
            });
    },
    promoDetailsModal: function () {
        $body.on('click', '.js-promo-details-link', async e => {
            const currentPromo = e.currentTarget;
            // get promo details from data attribute
            const { promoSheetId, promoPdSheetAvailable } = currentPromo.dataset;
            // if promoSheetId is exist to get data from AJAX response and update model content for selected promo
            if (!promoSheetId) return;
            const mainContainer = document.getElementById('main-content');
            const promoSheetContainer = queryFirst('.js-promo-sheet-container', mainContainer);
            let promoSheetHtml = queryFirst('#promo-container-' + promoSheetId, promoSheetContainer);
            // if promo sheet html is already exist and not empty, just return
            // modal will be shown from existing html content using bootstrap modal show method
            if (promoSheetHtml && promoSheetHtml.innerHTML.trim() !== '') {
                return;
            }

            e.preventDefault();
            // get promo details using AJAX call
            const promoBlockMsg = currentPromo.closest('.js-promo-block-messages');
            if (!promoBlockMsg) return;
            const { promoDetailsUrl } = promoBlockMsg.dataset;
            if (!promoDetailsUrl || !promoSheetId) return;
            const promoDetailsSheetUrl = promoDetailsUrl ? appendToUrl(promoDetailsUrl, { promoSheetId: promoSheetId, promoPDSheetAvailable: promoPdSheetAvailable }) : '';

            try {
                const response = await fetch(promoDetailsSheetUrl);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.text();
                if (data) {
                    if (!promoSheetHtml) {
                        // create the div container to hold promo sheet html if not exist
                        const newPromoSheetHtml = document.createElement('div');
                        newPromoSheetHtml.id = 'promo-container-' + promoSheetId;
                        promoSheetContainer.appendChild(newPromoSheetHtml);
                        promoSheetHtml = newPromoSheetHtml;
                    }
                    promoSheetHtml.appendChild(renderFragment(data));
                    const promoDetailsModal = queryFirst('#promo-' + promoSheetId);
                    $(promoDetailsModal).modal('show');
                }
            } catch (error) {
                // Clear widget content in case of error in the response
                if (promoSheetHtml) {
                    promoSheetHtml.innerHTML = '';
                }
            }
        });
    }
};
